export const errorStyle = {
  color: '#f44336',
  fontFamily: 'Arial',
  fontSize: '0.75rem',
  marginLeft: '10px',
};
